 
"use client";
import React, { useContext, useEffect, useState } from "react";
import { Context } from "../contexts/AppContext";
import { putData } from "../../lib/utils";
import { useParams } from "react-router-dom";

function FontDropDown() {
  const { value } = useContext(Context);
  const [appState, setAppState] = value;
  const { galleryId } = useParams();

  // =========================
  // Tabs
  // =========================
  const [activeTab, setActiveTab] = useState("style");

  // =========================
  // Dropdown States
  // =========================
  const [openHeading, setOpenHeading] = useState(false);
  const [openBody, setOpenBody] = useState(false);
  const [openLogo, setOpenLogo] = useState(false);

  // =========================
  // Fonts
  // =========================
  const [selectedHeadingFont, setSelectedHeadingFont] = useState(
    appState.currentFontFamilyVideoTitle || "Great Vibes"
  );

  const [selectedBodyFont, setSelectedBodyFont] = useState(
    appState.currentFontFamilyVideoSubTitle || "Poppins"
  );

  const [selectedLogoFont, setSelectedLogoFont] = useState(
    appState.currentFontFamilyLogoTxt || "Great Vibes"
  );

  // =========================
  // Colors
  // =========================
  const [titleColor, setTitleColor] = useState(
    appState.currentTitleColor || "#b8860b"
  );

  const [subTitleColor, setSubTitleColor] = useState(
    appState.currentSubTitleColor || "#374151"
  );

  const [logoColor, setLogoColor] = useState(
    appState.currentLogoColor || "#b8860b"
  );

  const [tempTitleColor, setTempTitleColor] = useState(titleColor);
  const [tempSubTitleColor, setTempSubTitleColor] =
    useState(subTitleColor);
  const [tempLogoColor, setTempLogoColor] =
    useState(logoColor);

  // =========================
  // Font Sizes
  // =========================
  const [titleSize, setTitleSize] = useState(
    appState.currentTitleFontSize || 60
  );

  const [subTitleSize, setSubTitleSize] = useState(
    appState.currentSubTitleFontSize || 22
  );

  const [logoSize, setLogoSize] = useState(
    appState.currentLogoFontSize || 42
  );

  const [tempTitleSize, setTempTitleSize] =
    useState(titleSize);

  const [tempSubTitleSize, setTempSubTitleSize] =
    useState(subTitleSize);

  const [tempLogoSize, setTempLogoSize] =
    useState(logoSize);

  // =========================
  // Sync Context
  // =========================
  useEffect(() => {
    setTempTitleColor(appState?.currentTitleColor);
    setTempSubTitleColor(
      appState?.currentSubTitleColor
    );
    setTempLogoColor(appState?.currentLogoColor);
  }, [
    appState.currentTitleColor,
    appState.currentSubTitleColor,
    appState.currentLogoColor,
  ]);

  // =========================
  // Fonts Array
  // =========================
  const headingFonts = [
    "Great Vibes",
    "Playfair Display",
    "Cinzel",
    "Cormorant Garamond",
    "Alex Brush",
    "Allura",
    "Parisienne",
    "Tangerine",
    "Dancing Script",
    "Sacramento",
  ];

  const bodyFonts = [
    "Great Vibes",
    "Playfair Display",
    "Cinzel",
    "Cormorant Garamond",
    "Alex Brush",
    "Allura",
    "Parisienne",
    "Tangerine",
    "Dancing Script",
    "Sacramento",
    "Poppins",
    "Montserrat",
    "Raleway",
    "Lato",
    "Nunito",
    "Roboto",
    "Open Sans",
    "Georgia",
    "Arial",
  ];

  // =========================
  // Font Save
  // =========================
  const handleFontSelect = async (
    font,
    type
  ) => {
    try {
      if (type === "heading") {
        setSelectedHeadingFont(font);
        setOpenHeading(false);

        await putData(
          `galleries/update-gallery-title/`,
          {
            fheading: font,
            galleryId,
          }
        );

        setAppState((prev) => ({
          ...prev,
          currentFontFamilyVideoTitle:
            font,
        }));
      }

      if (type === "body") {
        setSelectedBodyFont(font);
        setOpenBody(false);

        await putData(
          `galleries/update-gallery-title/`,
          {
            fbody: font,
            galleryId,
          }
        );

        setAppState((prev) => ({
          ...prev,
          currentFontFamilyVideoSubTitle:
            font,
        }));
      }

      if (type === "logo") {
        setSelectedLogoFont(font);
        setOpenLogo(false);

        await putData(
          `galleries/update-gallery-title/`,
          {
            flogo: font,
            galleryId,
          }
        );

        setAppState((prev) => ({
          ...prev,
          currentFontFamilyLogoTxt:
            font,
        }));
      }
    } catch (error) {
      console.log(error);
    }
  };

  // =========================
  // Apply Color
  // =========================
  const applyColor = async (type) => {
    try {
      if (type === "title") {
        setTitleColor(tempTitleColor);

        await putData(
          `galleries/update-gallery-title/`,
          {
            titleColor: tempTitleColor,
            galleryId,
          }
        );

        setAppState((prev) => ({
          ...prev,
          currentTitleColor:
            tempTitleColor,
        }));
      }

      if (type === "subtitle") {
        setSubTitleColor(
          tempSubTitleColor
        );

        await putData(
          `galleries/update-gallery-title/`,
          {
            subTitleColor:
              tempSubTitleColor,
            galleryId,
          }
        );

        setAppState((prev) => ({
          ...prev,
          currentSubTitleColor:
            tempSubTitleColor,
        }));
      }

      if (type === "logo") {
        setLogoColor(tempLogoColor);

        await putData(
          `galleries/update-gallery-title/`,
          {
            logoColor:
              tempLogoColor,
            galleryId,
          }
        );

        setAppState((prev) => ({
          ...prev,
          currentLogoColor:
            tempLogoColor,
        }));
      }
    } catch (error) {
      console.log(error);
    }
  };

  // =========================
  // Apply Size
  // =========================
  const applySize = async (type) => {
    try {
      if (type === "title") {
        setTitleSize(tempTitleSize);

        await putData(
          `galleries/update-gallery-title/`,
          {
            titleFontSize:
              tempTitleSize,
            galleryId,
          }
        );

        setAppState((prev) => ({
          ...prev,
          currentTitleFontSize:
            tempTitleSize,
        }));
      }

      if (type === "subtitle") {
        setSubTitleSize(
          tempSubTitleSize
        );

        await putData(
          `galleries/update-gallery-title/`,
          {
            subTitleFontSize:
              tempSubTitleSize,
            galleryId,
          }
        );

        setAppState((prev) => ({
          ...prev,
          currentSubTitleFontSize:
            tempSubTitleSize,
        }));
      }

      if (type === "logo") {
        setLogoSize(tempLogoSize);

        await putData(
          `galleries/update-gallery-title/`,
          {
            logoFontSize:
              tempLogoSize,
            galleryId,
          }
        );

        setAppState((prev) => ({
          ...prev,
          currentLogoFontSize:
            tempLogoSize,
        }));
      }
    } catch (error) {
      console.log(error);
    }
  };

  // =========================
  // Dropdown UI
  // =========================
  const renderDropdown = (
    title,
    fonts,
    selected,
    open,
    setOpen,
    type,
    sample,
    color
  ) => (
    <div className="relative bg-gradient-to-br from-white to-gray-50 rounded-3xl p-6 shadow-xl border border-gray-100">
      <div className="mb-2 text-sm font-semibold">
        {title}
      </div>

    <button
  onClick={() => setOpen(!open)}
  className="
    w-full
    bg-white
    border
    border-gray-200
    rounded-2xl
    px-4
    py-3
    shadow-sm
    hover:shadow-md
    transition-all
    flex
    justify-between
    items-center
  "
>
  <span
    style={{
      fontFamily: selected,
      color,
    }}
  >
    {selected}
  </span>

  <span className="text-gray-400">
    ▼
  </span>
</button>

      {open && (
 <div
  className={`
    absolute
    left-0
    w-full
    z-50
    bg-white
    border
    border-gray-200
    rounded-2xl
    shadow-2xl
    max-h-80
    overflow-y-auto
    ${
      type === "logo"
        ? "bottom-full -mb-6"
        : "top-full mt-2"
    }
  `}
>
          {fonts.map((font) => (
            <div
              key={font}
              onClick={() =>
                handleFontSelect(
                  font,
                  type
                )
              }
              className="
  px-5
  py-1
  border-b
  border-gray-100
  hover:bg-amber-50
  cursor-pointer
  transition-all
"
            >
              <div className="text-xs text-gray-400">
                {font}
              </div>

              <div
                style={{
                  fontFamily: font,
                  color,
                }}
                className="text-lg"
              >
                {sample}
              </div>
            </div>
          ))}
        </div>
      )}
    </div>
  );

  return (
    <div className="space-y-6 overflow-visible">
      {/* Tabs */}
    <div className="bg-gray-100 p-1 rounded-2xl flex">
  {[
    { id: "style", label: "Style" },
    { id: "color", label: "Colors" },
    { id: "size", label: "Sizes" },
  ].map((tab) => (
    <button
      key={tab.id}
      onClick={() => setActiveTab(tab.id)}
      className={`flex-1 py-3 rounded-xl text-sm font-semibold transition-all
      ${
        activeTab === tab.id
          ? "bg-white shadow text-black"
          : "text-gray-500"
      }`}
    >
      {tab.label}
    </button>
  ))}
</div>

      {/* STYLE */}
      {activeTab === "style" && (
        <div className="space-y-6">
          {renderDropdown(
            "Wedding Title Font",
            headingFonts,
            selectedHeadingFont,
            openHeading,
            setOpenHeading,
            "heading",
            "Harpreet ❤️ Simran",
            titleColor
          )}

          {renderDropdown(
            "Subtitle Font",
            bodyFonts,
            selectedBodyFont,
            openBody,
            setOpenBody,
            "body",
            "27 Feb 2025 • London",
            subTitleColor
          )}

          {renderDropdown(
            "Logo Text Font",
            headingFonts,
            selectedLogoFont,
            openLogo,
            setOpenLogo,
            "logo",
            "HS",
            logoColor
          )}
        </div>
      )}

      {/* COLOR */}
      {activeTab === "color" && (
        <div className="space-y-6">
          {[
            [
              "Title Color",
              tempTitleColor,
              setTempTitleColor,
              "title",
            ],
            [
              "Subtitle Color",
              tempSubTitleColor,
              setTempSubTitleColor,
              "subtitle",
            ],
            [
              "Logo Text Color",
              tempLogoColor,
              setTempLogoColor,
              "logo",
            ],
          ].map(
            ([
              label,
              value,
              setter,
              type,
            ]) => (
              <div
                key={type}
                className="border p-4 rounded-2xl"
              >
                <div className="mb-2 font-semibold">
                  {label}
                </div>

                <div className="flex items-center gap-4">
                  <input
                    type="color"
                    value={value}
                    className="w-11 h-11"
                    onChange={(e) =>
                      setter(
                        e.target.value
                      )
                    }
                  />

                  <button
                    onClick={() =>
                      applyColor(
                        type
                      )
                    }
                    className="px-4 py-2 bg-red-700 text-white rounded-lg"
                  >
                    Save Changes
                  </button>
                </div>
              </div>
            )
          )}
        </div>
      )}

      {/* SIZE */}
      {activeTab === "size" && (
        <div className="space-y-6">
          {[
            [
              "Title Font Size",
              tempTitleSize,
              setTempTitleSize,
              "title",
              20,
              100,
            ],
            [
              "Subtitle Font Size",
              tempSubTitleSize,
              setTempSubTitleSize,
              "subtitle",
              12,
              50,
            ],
            [
              "Logo Font Size",
              tempLogoSize,
              setTempLogoSize,
              "logo",
              10,
              80,
            ],
          ].map(
            ([
              label,
              value,
              setter,
              type,
              min,
              max,
            ]) => (
              <div
                key={type}
                className="border p-4 rounded-2xl"
              >
                <div className="font-semibold mb-2">
                  {label} ({value}px)
                </div>

                <input
                  type="range"
                  min={min}
                  max={max}
                  value={value}
                  onChange={(e) =>
                    setter(
                      e.target.value
                    )
                  }
                  className=" w-full
              accent-red-600
              cursor-pointer"
                />

                <button
                  onClick={() =>
                    applySize(type)
                  }
                  className="      mt-6
              w-full
              py-3
              rounded-2xl
              text-white
              font-semibold
              bg-gradient-to-r
              from-red-600
              to-red-800
              shadow-lg
              hover:shadow-xl
              hover:scale-[1.01]
              transition-all"
                >
                  Save Changes
                </button>
              </div>
            )
          )}
        </div>
      )}
    </div>
  );
}

export default FontDropDown;

